<template>
  <img
    v-bind="$attrs"
    :src="props.src || '/images/profile_dummy.svg'"
    @error="onError"
  />
</template>

<script setup lang="ts">
// @ts-ignore
const props = defineProps<{
  src: string | null;
}>();

// @ts-ignore
function onError(event: Event) {
  const target = event.target as HTMLImageElement;
  target.src = "/images/profile_dummy.svg";
}
</script>
